import React from 'react';

const Separator = () => <hr className="border-pea r-pvs" />;

export default Separator;



// WEBPACK FOOTER //
// ./safeTrade/resolution/separator.jsx